import { ElementEditedEvent } from "../../models/domain/element_edited_event";

import type PlannedBuildingElement from "../../models/domain/planned_building_element";

export function elementsPartialProgressUpdated(floorId: string, previousElementStates: PlannedBuildingElement[], nextElementStates: PlannedBuildingElement[]): ElementEditedEvent {
  return { ...new ElementEditedEvent(ELEMENTS_PARTIAL_PROGRESS_UPDATED, floorId, previousElementStates, nextElementStates) };
}

export const ELEMENTS_PARTIAL_PROGRESS_UPDATED = "elements_partial_progress_updated";
